import { Component, Inject, Input } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import { ClipboardService } from 'ngx-clipboard';
import { FacebookService } from 'ngx-facebook';

import { environment } from '../../../../environments/environment';
import { ToastService } from '../../../core/services/toast.service';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'gs-social-share',
    templateUrl: './social-share.component.html',
    standalone: false
})

export class SocialShareComponent {
  @Input() url: string;

  /**
   * Facebook messenger share used for mobile devices where application is triggered instead of browser popup
   *
   * @readonly
   * @type {SafeUrl}
   * @memberof SocialShareComponent
   */
  get facebookMessengerShareUrl(): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(`fb-messenger://share/?link=${encodeURIComponent(this.url)}&app_id=${encodeURIComponent(environment.facebookAppId)}`);
  }

  /**
   * Whatsapp share trigger url
   * https://wa.me/?text= - doesn't work anymore on mobile.
   *
   * @readonly
   * @type {SafeUrl}
   * @memberof SocialShareComponent
   */
  get whatsappShareUrl(): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(`https://api.whatsapp.com/send?text=${encodeURIComponent(this.url)}`);
  }

  constructor(
    private facebookService: FacebookService,
    private sanitizer: DomSanitizer,
    private clipboardService: ClipboardService,
    private toastService: ToastService,
    @Inject(DOCUMENT) private document: Document
  ) {

  }

  /**
   *SocialShare functionality of Events on Facebook
   * @param {string} EventCode
   * @param {string} Description
   * @param {string} EventName
   * @memberof SocialShareComponent
   */
  shareOnFacebook() {
    // const Event_title = EventName;
    // const description = Description.replace(/<(?:.|\n)*?>/gm, '');
    // const obj = {
    //   "og:title": "Unused title",
    //   "og:url": document.URL,
    //   "og:image": share_image,
    //   "og:description": "Unused description"
    // };
    this.facebookService.ui({
      method: 'share_open_graph',
      action_type: 'og.shares',
      action_properties: JSON.stringify({
        object: this.document.URL
      })
    });
  }

  /**
   * Share on facebook messenger
   * https://developers.facebook.com/docs/sharing/reference/send-dialog
   *
   * @memberof SocialShareComponent
   */
  shareOnMessenger() {
    this.facebookService.ui({
      method: 'send',
      app_id: environment.facebookAppId,
      link: this.url
    });
  }

  /**
   * Copy link to clipboard
   *
   * @memberof SocialShareComponent
   */
  copyLinkToClipboard() {
    this.clipboardService.copyFromContent(this.url);
    this.toastService.show('Succes', 'Link copiat cu succes.', 'success');
  }

}
